import {matchRoutes} from 'react-router-config';
import queryString from 'query-string';
import checkIntegrationTypeAccess from '@components/integration-type-access/check';
import checkPrivilegeAccess from '@components/privileges-access/check';
import {removeRoutePathExtraSlash} from '@utils/remove-route-path-extra-slash';

function fetchRouteData({
  history,
  location,
  route,
  dispatch,
  userIsAdmin = false,
  privileges = [],
  integrationType = ''
}) {
  const routePath = removeRoutePathExtraSlash(location.pathname);
  matchRoutes([route, ...(route.routes ?? [])], routePath)
    .filter(({route}) => route.fetchData || route.privilege || route.disallowedIntegrationTypes)
    .forEach(({route, match}) => {
      const isIntegrationTypeDisallowed =
        route.disallowedIntegrationTypes &&
        route.disallowedIntegrationTypes.length &&
        !checkIntegrationTypeAccess(route.disallowedIntegrationTypes, integrationType, userIsAdmin);
      const isPrivilegesDisallowed =
        route.privileges &&
        route.privileges.length &&
        !checkPrivilegeAccess(route.privileges, privileges);

      if (isIntegrationTypeDisallowed || isPrivilegesDisallowed) {
        history.replace({pathname: location.pathname, state: {}});
        history.push('/forbidden');
        return;
      }

      const fromModal = location.state && location.state.fromModal;
      const isExact = match.isExact;

      if (Array.isArray(route.fetchData) && route.fetchData.length !== 0 && !fromModal) {
        route.fetchData.filter(Boolean).forEach(fetchDataActionCreator => {
          dispatch(
            fetchDataActionCreator({
              ...match.params,
              searchQuery: queryString.parse(location.search),
              isExact: isExact
            })
          );
        });
      }
    });
}

export default fetchRouteData;
